export default __webpack_public_path__ + "static/geschaeftsfelder-d48647dd3d831e362b49f63c593b5aff.webp";